import { render } from "./TeamManagementView.vue?vue&type=template&id=d38fb7a4&scoped=true"
import script from "./TeamManagementView.vue?vue&type=script&lang=js"
export * from "./TeamManagementView.vue?vue&type=script&lang=js"

import "./TeamManagementView.vue?vue&type=style&index=0&id=d38fb7a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d38fb7a4"]])

export default __exports__